var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSleep16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7477 11.9965C13.836 11.8699 13.9201 11.7402 14 11.6076C14.3069 11.0982 14.5509 10.5465 14.7209 9.96332C14.4839 9.98757 14.2434 10 14 10C13.5347 10 13.0799 9.95459 12.64 9.86797C9.45638 9.24113 7.04747 6.45584 7.00069 3.09953C7.00023 3.06641 7 3.03323 7 3C7 2.31841 7.09741 1.65958 7.27907 1.03667C6.51065 1.11528 5.77904 1.31819 5.10466 1.62497C2.68343 2.72637 1 5.16659 1 8C1 11.866 4.13401 15 8 15C10.3803 15 12.483 13.812 13.7477 11.9965ZM11.4386 11.6303C10.5417 12.4796 9.33076 13 8 13C5.23858 13 3 10.7614 3 8C3 6.34195 3.80771 4.8715 5.05078 3.9617C5.43881 7.61458 8.01218 10.6149 11.4386 11.6303Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSleep16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;